export interface Ticket_PropsType{
    QueryType:string,
    Title:string,
    Description:string
}

export const TicketData : Ticket_PropsType = {
    QueryType:'1',
    Title:'',
    Description:'',
}

export interface ChatForm_PropsType{
    Comment:string,

}

export const ChatForm_Data : ChatForm_PropsType = {
    Comment:'',
}